import { DAYS_MAP } from "@/utils/consts";

export default {
  name: "ParsedDayScheduleCalendar",

  props: {
    workDays: {
      type: String,
      default: "012345"
    },
    workTime: {
      type: Array,
      default: null
    },
    workDate: {
      type: Array,
      default: null
    },
    specificDaysWorkHours: {
      type: Object,
      default: null
    },
    containerStyle: {
      type: Object,
      default: null
    },
    daysStyle: {
      type: Object,
      default: null
    },
    dayStyle: {
      type: Object,
      default: null
    }
  },

  computed: {
    days() {
      if (this.workDays !== null) {
        const __days = DAYS_MAP.map(day => ({
          value: DAYS_MAP.indexOf(day),
          name: day,
          isActive: this.workDays.includes(DAYS_MAP.indexOf(day))
        }));
        __days.push(__days.shift());
        return __days;
      }
      return "";
    }
  }
};
